import $ from 'jquery';
import { getHeight, getScrollTop, onScroll } from '../utils/window';
import shopify from '../utils/shopify';
// import Client from 'shopify-buy';
// import Cookie from 'js-cookie';

// for the product section/page. remember to activate the shopify plugin if using shopify

export default function productsPage() {

    if(!window.shopifyClient) {
        // You'll need to change the apikey and domain
        // remember to change the domain in the product.twig file as well.
        window.shopifyClient = new shopify('b40a37fc7dc6fca8bb0ca548e23a0b24', 'h-elp.myshopify.com');
    }
    // const client = new shopify('a46c806bc951b3d9dadbd0631e7251a1', 'cuvee-develop.myshopify.com');

    if(window.shopifyClient) {
        window.shopifyClient.setupCheckoutInfo();
        window.shopifyClient.setupCartContainer('.cart-num');
    }

    if($('.product-page').length > 0) {
        const $qtySelect = $('#qty_select');
        const $sizeSelect = $('#size_select');
        const $addToCartButton = $('.add-to-cart .button.submit');
        const $hiddenMainId = $('.add-to-cart [name="mainId"]');
        const $props = $('.add-to-cart [name="props"]');
        const props = JSON.parse($props.val());
        const $hiddenQuantity = $('.add-to-cart [name="quantity"]');
        const $price = $('.product-page_info .variant-price');
        
        // const client = new shopify('a46c806bc951b3d9dadbd0631e7251a1', 'cuvee-develop.myshopify.com');

        $qtySelect.on('change', function() {
            $hiddenQuantity.val(this.value);
        });

        $sizeSelect.on('change', function() {

            let json = JSON.parse(this.value);

            $hiddenMainId.val(json.id);
            $price.html('$'+json.price);
        });

        $addToCartButton.click(function(e){
            e.preventDefault();

            let cusAttr = [
                {
                    key: "summary",
                    value: props.summary
                },
            ];

            window.shopifyClient.addProductToCart([
                {
                    variantId: $hiddenMainId.val(),
                    quantity: parseInt($hiddenQuantity.val(), 10),
                    customAttributes: cusAttr,
                }
            ]);
        });
    }
}



// WEBPACK FOOTER //
// ./source/scripts/sections/products.js